import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import SubLayout from 'src/layouts/v2/ExternalLayout';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import TicketLayout from 'src/layouts/v2/TicketLayout';
import type { RouteGroup } from './types';

// Lazy load V2 HR Ticket components
const BiometricLog = lazy(() => import('src/pages/v2/HrTicket/BiometricLog'));
const AdvancePaymentTicket = lazy(() => import('src/pages/v2/HrTicket/AdvancePaymentTicket'));
const AddAdvancePaymentTicket = lazy(() => import('src/pages/v2/HrTicket/AddAdvancePaymentTicket'));
const TransportationTicket = lazy(() => import('src/pages/v2/HrTicket/TransportationTicket'));
const AddTransportationTicket = lazy(() => import('src/pages/v2/HrTicket/AddTransportationTicket'));
const LeaveTicket = lazy(() => import('src/pages/v2/HrTicket/LeaveTicket'));
const LeavePackage = lazy(() => import('src/pages/v2/HrTicket/LeavePackage'));
const AddLeaveTicket = lazy(() => import('src/pages/v2/HrTicket/AddLeaveTicket'));
const ResignationTicket = lazy(() => import('src/pages/v2/HrTicket/ResignationTicket'));
const AddResignationTicket = lazy(() => import('src/pages/v2/HrTicket/AddResignationTicket'));
const AddResignationTicketSub = lazy(() => import('src/pages/v2/Sub/AddResignationTicket'));
const ExpenseTrackingRequestTicket = lazy(() => import('src/pages/v2/HrTicket/ExpenseTrackingRequestTicket'));
const AddExpenseTrackingRequestTicket = lazy(() => import('src/pages/v2/HrTicket/AddExpenseTrackingRequestTicket'));
const OvertimeTicket = lazy(() => import('src/pages/v2/HrTicket/OvertimeTicket'));
const AddOvertimeTicket = lazy(() => import('src/pages/v2/HrTicket/AddOvertimeTicket'));
const BusinessTripTicket = lazy(() => import('src/pages/v2/HrTicket/BusinessTripTicket'));
const AddBusinessTripTicket = lazy(() => import('src/pages/v2/HrTicket/AddBusinessTripTicket'));
const EquipmentSupplyRequestTicket = lazy(() => import('src/pages/v2/HrTicket/EquipmentSupplyRequestTicket'));
const AddEquipmentSupplyRequestTicket = lazy(() => import('src/pages/v2/HrTicket/AddEquipmentSupplyRequestTicket'));
const AdditionalWorkingTimeTicket = lazy(() => import('src/pages/v2/HrTicket/AdditionalWorkingTimeTicket'));
const AddAdditionalWorkingTimeTicket = lazy(() => import('src/pages/v2/HrTicket/AddAdditionalWorkingTimeTicket'));
// const AdditionalWorkingTimePackage = lazy(() => import('src/pages/v2/HrTicket/AdditionalWorkingTimePackage'));

// Note: Purchase Request Ticket components don't exist yet in the HrTicket folder
// They might be planned for future implementation

export const hrTicketRoutes: RouteGroup = [
  // Biometric Log
  {
    path: urlPath.biometricLog.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BiometricLog,
    hasSidebar: false
  },

  // Advance Payment Tickets
  {
    path: urlPath.myAdvancePaymentTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdvancePaymentTicket,
    hasSidebar: true
  },
  {
    path: urlPath.advancePaymentTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myAdvancePaymentTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.advancePaymentTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdvancePaymentTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myAdvancePaymentTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdvancePaymentTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.advancePaymentTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdvancePaymentTicket,
    hasSidebar: true
  },
  {
    path: urlPath.advancePaymentTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddAdvancePaymentTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.advancePaymentTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddAdvancePaymentTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Transportation Tickets
  {
    path: urlPath.myTransportationTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.transportationTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myTransportationTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.transportationTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.transportationTicketConfirm.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.transportationTicketHandle.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myTransportationTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.transportationTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.transportationTicketConfirm.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.transportationTicketHandle.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.transportationTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddTransportationTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.transportationTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddTransportationTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Leave Tickets
  {
    path: urlPath.myLeaveTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicket,
    hasSidebar: true
  },
  {
    path: urlPath.leaveTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myLeaveTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.leaveTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicket,
    hasSidebar: true
  },
  {
    path: urlPath.leavePackageApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeavePackage,
    hasSidebar: true
  },
  {
    path: `${urlPath.myLeaveTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.leaveTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.leavePackageApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeavePackage,
    hasSidebar: true
  },
  {
    path: urlPath.leaveTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddLeaveTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.leaveTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddLeaveTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: urlPath.myLeavePackage.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeavePackage,
    hasSidebar: true
  },
  {
    path: `${urlPath.myLeavePackage.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeavePackage,
    hasSidebar: true
  },

  // Resignation Tickets
  {
    path: urlPath.myResignationTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.resignationTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myResignationTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.resignationTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myResignationTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.resignationTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTicket,
    hasSidebar: true
  },
  {
    path: urlPath.resignationTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddResignationTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.resignationTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddResignationTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: urlPath.resignationTicketAddSub.location,
    Layout: MainLayoutV2,
    SubLayout: SubLayout,
    Component: AddResignationTicketSub,
    isUsePathV2: true,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.resignationTicketEditSub.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: SubLayout,
    Component: AddResignationTicketSub,
    isUsePathV2: true,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Expense Tracking Request Tickets
  {
    path: urlPath.expenseTrackingRequestTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ExpenseTrackingRequestTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.expenseTrackingRequestTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ExpenseTrackingRequestTicket,
    hasSidebar: true
  },
  {
    path: urlPath.expenseTrackingRequestTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddExpenseTrackingRequestTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.expenseTrackingRequestTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddExpenseTrackingRequestTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Overtime Tickets
  {
    path: urlPath.myOvertimeTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: urlPath.overtimeTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myOvertimeTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.overtimeTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: urlPath.overtimeTicketSupervisorConfirm.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myOvertimeTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.overtimeTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.overtimeTicketSupervisorConfirm.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeTicket,
    hasSidebar: true
  },
  {
    path: urlPath.overtimeTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddOvertimeTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.overtimeTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddOvertimeTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Business Trip Tickets
  {
    path: urlPath.myBusinessTripTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripTicket,
    hasSidebar: true
  },
  {
    path: urlPath.businessTripTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myBusinessTripTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.businessTripTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myBusinessTripTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.businessTripTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripTicket,
    hasSidebar: true
  },
  {
    path: urlPath.businessTripTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddBusinessTripTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.businessTripTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddBusinessTripTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  // Equipment Supply Request Tickets
  {
    path: urlPath.myEquipmentSupplyRequestTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: EquipmentSupplyRequestTicket,
    hasSidebar: true
  },
  {
    path: urlPath.equipmentSupplyRequestTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myEquipmentSupplyRequestTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.equipmentSupplyRequestTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: EquipmentSupplyRequestTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myEquipmentSupplyRequestTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: EquipmentSupplyRequestTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.equipmentSupplyRequestTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: EquipmentSupplyRequestTicket,
    hasSidebar: true
  },
  {
    path: urlPath.equipmentSupplyRequestTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddEquipmentSupplyRequestTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.equipmentSupplyRequestTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddEquipmentSupplyRequestTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },

  // Additional Working Time Tickets
  {
    path: urlPath.myAdditionalWorkingTimeTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicket,
    hasSidebar: true
  },
  {
    path: urlPath.additionalWorkingTimeTicket.location,
    Layout: MainLayoutV2,
    redirect: urlPath.myAdditionalWorkingTimeTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },
  {
    path: urlPath.additionalWorkingTimeTicketApproval.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.additionalWorkingTimeTicketApproval.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicket,
    hasSidebar: true
  },
  {
    path: `${urlPath.myAdditionalWorkingTimeTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicket,
    hasSidebar: true
  },
  {
    path: urlPath.additionalWorkingTimeTicketAdd.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddAdditionalWorkingTimeTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  },
  {
    path: `${urlPath.additionalWorkingTimeTicketEdit.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AddAdditionalWorkingTimeTicket,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true,
    isHideDetailLayout: true
  }
  // {
  //   path: urlPath.myAdditionalWorkingTimePackage.location,
  //   Layout: MainLayoutV2,
  //   SubLayout: TicketLayout,
  //   Component: AdditionalWorkingTimePackage,
  //   hasSidebar: true
  // },
  // {
  //   path: urlPath.additionalWorkingTimePackageApproval.location,
  //   Layout: MainLayoutV2,
  //   SubLayout: TicketLayout,
  //   Component: AdditionalWorkingTimePackage,
  //   hasSidebar: true
  // },
  // {
  //   path: `${urlPath.myAdditionalWorkingTimePackage.location}/:id`,
  //   Layout: MainLayoutV2,
  //   SubLayout: TicketLayout,
  //   Component: AdditionalWorkingTimePackage,
  //   hasSidebar: true
  // }
  // {
  //   path: `${urlPath.additionalWorkingTimePackageApproval.location}/:id`,
  //   Layout: MainLayoutV2,
  //   SubLayout: TicketLayout,
  //   Component: AdditionalWorkingTimePackage,
  //   hasSidebar: true
  // }
];
